(ns practitest.frontend.integration-settings.integration-field-mapping.subs
  (:require [re-frame.core :as re-frame]))

(re-frame/reg-sub
  ::state
  (fn [db _]
    (:integration-field-mapping db)))

(re-frame/reg-sub
  ::initialized?
  :<- [::state]
  (fn [state _]
    (contains? state :rows)))

(re-frame/reg-sub
  ::rows
  :<- [::state]
  (fn [state _]
    (:rows state [])))

(re-frame/reg-sub
  ::ex-fields
  :<- [::state]
  (fn [state _]
    (:ex-fields state [])))

(re-frame/reg-sub
  ::pt-fields
  :<- [::state]
  (fn [state _]
    (:pt-fields state [])))

(re-frame/reg-sub
  ::valid-pairs
  :<- [::state]
  (fn [state _]
    (:valid-pairs state [])))

(re-frame/reg-sub
  ::bugtracker-name
  :<- [::state]
  (fn [state _]
    (:bugtracker-name state "")))

(re-frame/reg-sub
  ::saving?
  :<- [::state]
  (fn [state _]
    (:saving? state false)))

(re-frame/reg-sub
  ::changes-made?
  :<- [::state]
  (fn [state _]
    (:changes-made? state false)))

(re-frame/reg-sub
  ::cancel-url
  :<- [::state]
  (fn [state _]
    (:cancel-url state "")))

(re-frame/reg-sub
  ::sub-tabs-props
  :<- [::state]
  (fn [state _]
    {:active            (:active-tab state "")
     :tabs              (:tabs state [])
     :bugtracker-label  (:bugtracker-name state "")
     :identifier        (:identifier state "")}))
